import React, { Component } from 'react';

class Title extends Component {
  render() {
    return (
      <h1 style={this.props.style}><a href="https://sunday-desert.github.io/ilyylm">ILYYL.M</a></h1>
    );
  }
}

export default Title;
